import { useAlertStore } from '@/store/alert'
import { googleLogin, googleRegister } from '@/service/login'
import { RegistrationType } from '@/types/member'
import type { SocialLoginProvider } from '@/types/socialLogin'

export function createGoogleProvider(): SocialLoginProvider {
  const alertStore = useAlertStore()
  const { t } = useI18n()

  return {
    type: 'google',
    registrationType: RegistrationType.GOOGLE,
    login: ctx => googleLogin(ctx.token),
    register: (ctx, param) => googleRegister(ctx.token, param),
    resolveRedirectUrl: () => undefined,
    onError: (_ctx, error: any) => {
      console.error('googleProvider: error', error)
      alertStore.error(error?.data?.message || t('member_auth_login_failed'))
    },
  }
}
